import { createSvgIcon } from '@mui/material';

export const OrderPositionView = createSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M9 14H21V11H9V14ZM7 14V11H3V14H7ZM9 6V9H21V6H9ZM7 6H3V9H7V6ZM9 19H21V16H9V19ZM7 19V16H3V19H7ZM3 4H21C22.1046 4 23 4.89543 23 6V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V6C1 4.89543 1.89543 4 3 4Z"
  />,
  'CnxOrderPositionView',
);
